const eventPrefix = 'sm360.widgets';

export default {
    GARAGE_ADDED: `${eventPrefix}.garage.added`,
    FINANCING_CREATED: `${eventPrefix}.financing.created`,
    TRADEIN_CREATED: `${eventPrefix}.tradein.created`,
};



// WEBPACK FOOTER //
// ./src/constants/events.js